import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaSpinner } from 'react-icons/fa';
import { FunctionComponent } from 'react';
import axios from 'axios';

interface Props {
  setIsLoggedIn: (value: boolean) => void;
}

const SocialLoginCallback: React.FC<Props> = ({ setIsLoggedIn }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const FaSpinnerIcon = FaSpinner as FunctionComponent<{ className?: string }>;

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const code = searchParams.get('code');
    const provider = location.pathname.split('/')[2]; // e.g., 'apple' or 'facebook'
    const error = searchParams.get('error');

    if (error) {
      navigate('/login', { state: { message: error || 'Social login failed' } });
      return;
    }

    if (code && provider) {
      const authenticate = async () => {
        try {
          const res = await axios.get(`https://www.eatmeatapp.com/api/connect/${provider}/callback`, {
            params: { code },
            headers: { 'Content-Type': 'application/json' },
            timeout: 15000,
          });

          if (res.status === 200) {
            const { jwt, user } = res.data;
            localStorage.setItem('jwt', jwt);
            localStorage.setItem('userId', user.id.toString());
            setIsLoggedIn(true);
            const from = localStorage.getItem('socialLoginRedirect') || '/';
            localStorage.removeItem('socialLoginRedirect');
            navigate(from);
          } else {
            navigate('/login', { state: { message: 'Social login failed' } });
          }
        } catch (err: any) {
          navigate('/login', { state: { message: err.response?.data?.error?.message || 'Social login failed' } });
        }
      };
      authenticate();
    } else {
      navigate('/login', { state: { message: 'Invalid social login response' } });
    }
  }, [navigate, setIsLoggedIn, location]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-text flex items-center">
        <FaSpinnerIcon className="animate-spin mr-2 h-6 w-6" />
        Processing login...
      </div>
    </div>
  );
};

export default SocialLoginCallback;